<template>
  <div v-if="logs.results">
      <strong>Logs for order {{ orderID }}</strong>
      <div v-if="logs.results && logs.results.length">
        <table class="table is-bordered" align="center">
          <thead>
              <tr>
                  <th>Event ID</th>
                  <th>Event Type</th>
                  <th>Event Time</th>
                  <th>Event Data</th>
                  <th>Destination</th>
                  <th>Destination Address</th>
                  <th>Result</th>
                  <th>Reply</th>
                  <th>Reply Data</th>
                  <th>Note</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="event in logs.results" v-bind:class="{ failed: event_failed(event) }">
                  <td>{{event.id}}</td>
                  <td>{{event.event_type}}</td>
                  <td>{{ to_local(event.timestamp) }}</td>
                  <td>
                    <a v-if="is_long(event.event_data)" href="#" @click="show_msg_modal(event.event_data)">Show {{ xml_tag(event.event_data) }}</a>
                    <span v-else>{{event.event_data}}</span>
                  </td>
                  <td>{{event.destination}}</td>
                  <td>{{event.destination_address}}</td>
                  <td>{{event.result}}</td>
                  <td>{{event.reply}}</td>
                  <td>
                    <a v-if="is_long(event.reply_data)" href="#" @click="show_msg_modal(event.reply_data)">Show {{ xml_tag(event.reply_data) }}</a>
                    <span v-else>{{event.reply_data}}</span>
                  </td>
                  <td>
                    <a v-if="is_long(event.note)" href="#" @click="show_msg_modal(event.note)">Show {{ xml_tag(event.note) }}</a>
                    <span v-else>{{event.note}}</span>
                  </td>
              </tr>
          </tbody>
          <Pagination ref="logs_paginator" :dest_obj="this" :dest_name="'logs'" :endpoint="requestUrl"/>
        </table>
      </div>
      <div v-else>
        No log found...
      </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import moment from 'moment'
    import Pagination from './Pagination'

    export default {
      name: 'OrderStatusLogs',
      created () {
        this.fetchData()
      },
      computed: {
        requestUrl () {
          return `${this.$constants.EVENT_LOGS}/${this.$route.params.order_id}`
        },
        orderID () {
          return this.$route.params.order_id
        }
      },
      data () {
        return {
          logs: {
            prev_page: null,
            next_page: null,
            results: null
          }
        }
      },
      components: {
        Pagination
      },
      methods: {
        fetchData () {
          axios.get(this.requestUrl)
            .then(response => {
              this.logs = response.data.items
            })
            .catch(error => {
              this.logs = {
                prev_page: null,
                next_page: null,
                results: null
              }
              console.log(error.msg)
            })
        },
        sync_failed (event) {
          return event.status === 'failed' || event.hold_status === 'failed' || event.fulfillment_status === 'failed'
        },

        event_failed (event) {
          return event.result === 'failed' || event.result === 'failure'
        },

        is_long (msg) {
          if (!msg) {
            return false
          }

          return msg.length > 25
        },

        xml_tag (msg) {
          const pattern = /<.*>/g
          const parts = pattern.exec(msg)

          if (parts) {
            return '(XML)'
          }

          return ''
        },

        show_msg_modal (msg) {
          this.$root.open_message_modal(msg, true)
        },

        to_local (utcDT) {
          return moment(utcDT).format('DD/MM/YYYY HH:mm:ss')
        }
      }
    }

</script>

<style scoped>

</style>
